import {
    collection,
    addDoc,
    query,
    where,
    orderBy,
    getDocs,
    doc,
    updateDoc,
    deleteDoc,
} from 'firebase/firestore';
import { db } from '../../config/firebase';
import { Chat, ChatMessage } from '../../types';

const CHATS_COLLECTION = 'chats';
const MESSAGES_COLLECTION = 'messages';

export async function createChat(userId: string, model: string): Promise<string> {
    const chatData = {
        userId,
        model,
        title: 'Nova Conversa',
        createdAt: Date.now(),
        updatedAt: Date.now(),
        tokenUsage: 0,
        isArchived: false
    };

    const docRef = await addDoc(collection(db, CHATS_COLLECTION), chatData);
    return docRef.id;
}

export async function getUserChats(userId: string): Promise<Chat[]> {
    const q = query(
        collection(db, CHATS_COLLECTION),
        where('userId', '==', userId),
        orderBy('updatedAt', 'desc')
    );

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    } as Chat));
}

export async function addMessage(chatId: string, message: Omit<ChatMessage, 'id' | 'createdAt'>): Promise<ChatMessage> {
    const messageData = {
        ...message,
        createdAt: Date.now()
    };

    const messagesRef = collection(db, CHATS_COLLECTION, chatId, MESSAGES_COLLECTION);
    const docRef = await addDoc(messagesRef, messageData);

    // Update chat timestamp
    const chatRef = doc(db, CHATS_COLLECTION, chatId);
    await updateDoc(chatRef, {
        updatedAt: Date.now()
    });

    return {
        id: docRef.id,
        ...messageData
    };
}

export async function getChatMessages(chatId: string): Promise<ChatMessage[]> {
    const q = query(
        collection(db, CHATS_COLLECTION, chatId, MESSAGES_COLLECTION),
        orderBy('createdAt', 'asc')
    );

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    } as ChatMessage));
}

export async function updateChatTitle(chatId: string, title: string): Promise<void> {
    const chatRef = doc(db, CHATS_COLLECTION, chatId);
    await updateDoc(chatRef, { title });
}

export async function archiveChat(chatId: string): Promise<void> {
    const chatRef = doc(db, CHATS_COLLECTION, chatId);
    await updateDoc(chatRef, { isArchived: true });
}

export async function updateTokenUsage(chatId: string, usage: number): Promise<void> {
    const chatRef = doc(db, CHATS_COLLECTION, chatId);
    await updateDoc(chatRef, { tokenUsage: usage });
}

export async function updateChatModel(chatId: string, model: string): Promise<void> {
    const chatRef = doc(db, CHATS_COLLECTION, chatId);
    await updateDoc(chatRef, { model, updatedAt: Date.now() });
}

export async function deleteChat(chatId: string): Promise<void> {
    const chatRef = doc(db, CHATS_COLLECTION, chatId);
    await deleteDoc(chatRef);
}
